module.exports = __webpack_public_path__ + "img/gu.821be54a.svg";